import QuickGroupMaintenances from './QuickGroupMaintenances';
export default QuickGroupMaintenances;


// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickGroupMaintenances/index.js